import { AnimatePresence, motion } from 'framer-motion';

import { Box, SxProps, Theme, useTheme } from '@mui/material';

import { EMPTY_FORMS_CONTAINER_ANIM, EMPTY_FORMS_ITEM_ANIM, ITEM_ANIM } from './animations/animations';

export interface EditPanelConfig {
  title: string;
  subtitle: string | JSX.Element;
}
export interface EditPanelProps {
  formComponent: JSX.Element;
  viewComponent: JSX.Element;
  mode: "view" | "edit";
}

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    root: {
      display: "block",
      position: "relative",
    },
    animContainer: {
      position: "relative",
    },
  };
};

export default function EditPanel(props: EditPanelProps) {
  const { mode, formComponent, viewComponent } = props;

  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Box sx={styles.root}>
      <Box sx={styles.animContainer}>
        <motion.div
          variants={EMPTY_FORMS_CONTAINER_ANIM}
          initial="hidden"
          animate="visible"
        >
          <AnimatePresence>
            {mode === "edit" && (
              <motion.div
                initial="hidden"
                animate="visible"
                exit={{
                  overflow: "hidden",
                  position: "absolute",
                  width: "100%",
                  height: 0,
                  opacity: 0,
                  top: 0,
                  transition: { duration: 0.2 },
                }}
                variants={EMPTY_FORMS_ITEM_ANIM}
              >
                {formComponent}
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
        <motion.div
          variants={EMPTY_FORMS_CONTAINER_ANIM}
          initial="hidden"
          animate="visible"
        >
          <AnimatePresence>
            {mode === "view" && (
              <motion.div
                initial="hidden"
                animate="visible"
                exit={{
                  overflow: "hidden",
                  position: "absolute",
                  width: "100%",
                  height: 0,
                  opacity: 0,
                  y: -20,
                  top: 0,
                  transition: { duration: 0.2 },
                }}
                variants={ITEM_ANIM}
              >
                {viewComponent}
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </Box>
    </Box>
  );
}
